<lex-case-analytics-item [noDataInCase]="noDataInCase$">
    @if (reviewSetSummary === null) {
        <div card-header-content-primary *ngIf="!shouldShowLoader" [@appear]>
            <div>Reviews <span>({{displayedReviewSetCount}}</span> of <span>{{caseReviewSetCount}})</span></div>
            <div>{{caseReviewDocCount | number}}</div>
            <div>Documents in <b>review sets</b></div>
        </div>
    }
    @else {
        <div card-header-content-primary *ngIf="!shouldShowLoader" [@appear]>
            <div>{{reviewSetSummary.title}}</div>
            <div>
                <span *ngIf="reviewSetSummary.status === docStatusConfig.Complete.label" style="display: inline-block;" [@appear]>{{reviewSetSummary.docStatusCount | number}}</span>
                <span *ngIf="reviewSetSummary.status === docStatusConfig.NotStarted.label" style="display: inline-block;" [@appear]>{{reviewSetSummary.docStatusCount | number}}</span>
                <span *ngIf="reviewSetSummary.status === docStatusConfig.NotReviewed.label" style="display: inline-block;" [@appear]>{{reviewSetSummary.docStatusCount | number}}</span>

                <span class="review-set-doc-count-separator"> of </span>{{reviewSetSummary.docTotalCount | number}}</div>
            <div>
                Documents are
                <b *ngIf="reviewSetSummary.status === docStatusConfig.Complete.label" style="display: inline-block;" [@appear]>reviewed</b>
                <b *ngIf="reviewSetSummary.status === docStatusConfig.NotStarted.label" style="display: inline-block;" [@appear]>not started</b>
                <b *ngIf="reviewSetSummary.status ===  docStatusConfig.NotReviewed.label" style="display: inline-block;" [@appear]>not reviewed</b>
            </div>
        </div>
    }
    <div card-body-content-chart *ngIf="chartData.datasets.length > 0"  [ngClass]="{'loading': shouldShowLoader === true}">
        <canvas
            baseChart
            type="bar"
            [data]="chartData"
            [options]="ngChartOptions"
            [plugins]="ngChartPlugins"
            [legend]="true"
            (chartHover)="displayReviewSetSummary($event)"
            (chartClick)="selectReviewSet($event)">
        </canvas>
    </div>
  <div card-body-content-chart *ngIf="shouldShowLoader" style="display: flex; align-items: center; justify-content: center;">
    <i card-body-loading-icon class="fa-light fa-chart-waterfall fa-fade" style="font-size: 19.2vh;"></i>
  </div>
    <div card-header-no-content >
        <div>Reviews</div>
        <div>0</div>
        <div>Documents in <b>review sets</b></div>
    </div>
    <a card-no-content-button *inRole="[roles.AccountFeatureSet, roles.Administrator]" [routerLink]="['/', 'discovery', 'review-sets']" >
        <button mat-flat-button class="no-data-button">
            <span>Click here to add a review set</span>
        </button>
    </a>
</lex-case-analytics-item>
